import styles from './SARABanner.less';

import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import { campaignLinkClicked } from 'store/location/location';
import { ScreenReaderOnly } from 'seek-style-guide/react';
import ExternalLink from 'ExternalLink/ExternalLink';

const saraLinkAU = 'https://www.seek.com.au/career-advice/the-2016-seek-annual-recruitment-awards-winners';
const saraLinkNZ = 'https://www.seek.co.nz/career-advice/the-2016-seek-annual-recruitment-awards-winners';

const mapDispatchToProps = dispatch => ({
  bannerClick: () => {
    dispatch(campaignLinkClicked({
      linkName: 'seek:au:sara+banner',
      trackingCode: 'sk:main:au:home:sara:banner:find+out+more'
    }));
  }
});

@connect(null, mapDispatchToProps)
export default class SARABanner extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    bannerClick: PropTypes.func.isRequired
  };

  render() {
    const { bannerClick, locale } = this.props;
    return (
      <div className={styles.root}>
        <div className={styles.container}>

          <div className={styles.saraBanner}>
            <div className={styles.saraContent}>
              <h1 className={styles.saraLogo}>
                <ScreenReaderOnly>
                  SEEK Annual Recruitment Awards 2016: Seeking Excellence
                </ScreenReaderOnly>
              </h1>
              <div className={styles.saraDescription}>
                <p>SEEK recognises the following recruiters for best practice in 2016.</p>
                <ExternalLink
                  onLinkClick={bannerClick}
                  href={locale === 'NZ' && saraLinkNZ || saraLinkAU}>
                  <button className={styles.saraButton}>Find out who won</button>
                </ExternalLink>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** ./app/components/HomePage/components/SARABanner/SARABanner.js
 **/